import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTariffRegionLookup extends Layout {
    sourceTariffRegion: DataSource;
    tableTariffRegionLookup: Table;
}
